import React from "react"
import { Breadcrumb, Crumb } from "gatsby-plugin-breadcrumb"

import "../styles/breadcrumb.css"

export interface BreadcrumbComponentProps {
  pageContext: {
    breadcrumb?: {
      crumbs: Crumb[]
    }
  }
}

const BreadcrumbComponent = ({ pageContext }: BreadcrumbComponentProps) => {
  if (!pageContext.breadcrumb) {
    return null
  }

  return (
    <div className="breadcrumb-container">
      <div className="container">
        <Breadcrumb crumbs={pageContext.breadcrumb.crumbs} />
      </div>
    </div>
  )
}

export default BreadcrumbComponent
